/* The Haaland Code — restrained scroll-reveal and parallax. Respects prefers-reduced-motion. */
(function () {
  'use strict';

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function animationLevel() {
    return document.body ? document.body.getAttribute('data-hc-animate') || 'full' : 'full';
  }

  function initReveal() {
    const items = document.querySelectorAll('.hc-reveal');
    if (!items.length) return;

    if (prefersReducedMotion || animationLevel() === 'none' || !('IntersectionObserver' in window)) {
      items.forEach(function (el) {
        el.classList.add('hc-in-view');
      });
      return;
    }

    const observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('hc-in-view');
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
    );

    items.forEach(function (el) {
      observer.observe(el);
    });
  }

  function initParallax() {
    if (prefersReducedMotion || animationLevel() !== 'full') return;
    const visuals = document.querySelectorAll('[data-hc-parallax]');
    if (!visuals.length) return;

    let ticking = false;
    function update() {
      visuals.forEach(function (el) {
        const rect = el.getBoundingClientRect();
        const vh = window.innerHeight || document.documentElement.clientHeight;
        const progress = (vh - rect.top) / (vh + rect.height);
        const offset = (progress - 0.5) * 24;
        el.style.transform = 'translateY(' + offset.toFixed(2) + 'px)';
      });
      ticking = false;
    }

    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          window.requestAnimationFrame(update);
          ticking = true;
        }
      },
      { passive: true }
    );
    update();
  }

  ready(function () {
    initReveal();
    initParallax();
  });
})();
